import Icon from '../components/Icon.vue'

Icon.register({
  'user-astronaut': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M64 224c-8.8 0-16-7.2-16-16v-96c0-8.8 7.2-16 16-16h13.5c24.7-56.5 80.9-96 146.5-96s121.8 39.5 146.5 96h13.5c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16h-13.5c-24.7 56.5-80.9 96-146.5 96s-121.8-39.5-146.5-96h-13.5zM104 136v24c0 53 43 96 96 96h48c53 0 96-43 96-96v-24c0-22.1-21.5-40-48-40h-144c-26.5 0-48 17.9-48 40zM176 208l-12-36-36-12 36-12 12-36 12 36 36 12-36 12zM327.6 321.4c67.5 7.1 120.4 63.6 120.4 133v9.6c0 26.5-21.5 48-48 48h-80v-64c0-17.7-14.3-32-32-32h-128c-17.7 0-32 14.3-32 32v64h-80c-26.5 0-48-21.5-48-48v-9.6c0-69.4 52.9-125.9 120.4-133 29.9 19.3 65.4 30.6 103.6 30.6s73.7-11.3 103.6-30.6zM272 448c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zM176 448c8.8 0 16 7.2 16 16v48h-32v-48c0-8.8 7.2-16 16-16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-astronaut.js
// module id = 2056
// module chunks = 0